import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_START,
  FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_ERROR,
  FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_SUCCESS,
  FILTER_SEARCH_BG_RESULTS_RESET_STATE,
} from 'actions/filterSearchBgResults';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [FILTER_SEARCH_BG_RESULTS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function filterSearchBgResults(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
